import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { generateRowData } from 'Store/lists/utilities';

import ListRow from 'Components/ListRow/ListRow';

const StatsListRow = memo(({ data, columnIds, ...props }) => {
  const [pairs, setPairs] = useState([]);

  useEffect(() => {
    if (pairs.length === 0) {
      const row = generateRowData(columnIds, data);
      setPairs(columnIds.map(key => ({ key, value: row[key] })));
    }
  });

  return (
    <ListRow
      columnIds={columnIds}
      data={pairs}
      status={data.school_deactivated ? 'deactivated' : null}
      additionalClassNames={props.rowIndex % 2 ? ' ListRow--dark' : undefined}
      {...props}
    />
  );
});

StatsListRow.propTypes = {
  data: PropTypes.object.isRequired,
  columnIds: PropTypes.array.isRequired,
  rowIndex: PropTypes.number.isRequired,
};

export default StatsListRow;
